module.exports = __webpack_public_path__ + "static/media/dirt-icon@3x.ee5e34f5.png";